import React, { useState, useEffect, useRef } from "react";
import Typed from "typed.js";
import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";
import Footer from "../Components/Footer";
import { isMobile } from "react-device-detect";
import Chart from "react-apexcharts";
import RouteApi from "../Backend/Backend";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import lottie from "lottie-web";
import confetti from 'canvas-confetti'; // only if you want confetti 🎉
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PaystackPayment from "../Components/PaystackPayment";
import { toast } from "react-toastify"; // Import Toastify for notifications


const Control = () => {

  const { id } = useParams();

  const { fetchWalletData, verifyPayment, students, teachers, getAiResponse } = RouteApi();

  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);

  const [isloading, setisLoading] = useState(false);

  const user = useSelector((state) => state.auth?.user);
  
    // Get user details
    const fname = user?.ghostuser || ""; // Default to empty if not available
    const email = user?.email || "";

  useEffect(() => {
    if(email){
    fetchWalletDataResult();
    }
  }, []);

  const fetchWalletDataResult = async () => {
    try {
      const response = await fetchWalletData(email); // your backend route
      setWallet(response);

      console.log(response);

    } catch (error) {
      console.error("Error fetching wallet data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [amount, setAmount] = useState("");

  const handleSuccess = (response) => {
    toast.success("Payment successful! Reference: " + response.reference);
    // ✅ Optionally: auto-close modal or refresh wallet balance
    handlePaymentSuccess(response.reference);
    const modal = window.bootstrap.Modal.getInstance(
      document.getElementById("paymentModal")
    );
    modal.hide();
  };

  const handlePaymentSuccess = async (reference) => {
    const result = await verifyPayment(reference);
  
    if (result.status === "success") {
      toast.success("Payment verified successfully!");
      fetchWalletDataResult(); // Refresh wallet after verification
    } else {
      toast.error(result.message || "Verification failed");
    }

  };
  
  const [searchFrom, setSearchFrom] = useState("");
  const [searchTo, setSearchTo] = useState("");
  const [selectedFrom, setSelectedFrom] = useState(null);
  const [selectedTo, setSelectedTo] = useState(null);
  const movementCutoff = "2026-10-07 11:18:51";
  const isProtectedFromMovement = (student) => student?.trn_date && String(student.trn_date).slice(0, 19) >= movementCutoff;

  // 🏫 Static class list
  const classList = [
    "JSS1", "JSS2", "JSS3",
    "SSS1", "SSS2", "SSS3", "GRADUATED",
    "Grade 1", "Grade 2", "Grade 3", "Grade 4", "Grade 5", "Grade 6",
    "kG 1", "kG 2", "NUR 1", "NUR 2", "Playgroup"
  ];

  // 🔍 Filter students + class names dynamically
  const filterOptions = (search) => {
    if (!search) return [];

    const results = [];

    // 🔸 Filter Students (dynamic)
    const matchedStudents = (students || [])
      .filter((student) => {
        if (isProtectedFromMovement(student)) return false;
        const fullName = `${student.fstname || ""} ${student.lstname || ""}`.toLowerCase();
        return (
          fullName.includes(search.toLowerCase()) ||
          (student.stud_id && student.stud_id.toString().includes(search))
        );
      })
      .slice(0, 10)
      .map((student) => ({
        type: "student",
        label: `${student.fstname} ${student.lstname}`,
        sub: `ID: ${student.stud_id}`,
        value: student,
      }));

    // 🔸 Filter Class List (static)
    const matchedClasses = classList
      .filter((cls) => cls.toLowerCase().includes(search.toLowerCase()))
      .map((cls) => ({
        type: "class",
        label: cls,
        sub: "Class Category",
        value: cls,
      }));

    // 🧩 Combine results
    return [ ...matchedClasses, ...matchedStudents];
  };

  const filteredFrom = filterOptions(searchFrom);
  const filteredTo = filterOptions(searchTo);

  const handleSelect = (setterSearch, setterSelected, option) => {
    setterSearch(option.label);
    setterSelected(option);
  };

    // 👨‍🏫 Teachers Search (for "Move From" input)
   const filteredFromTeacher = (teachers || [])
  .filter((teacher) => {
    const fullName = `${teacher.fname || ""} ${teacher.username || ""}`.toLowerCase();
    return searchFrom ? fullName.includes(searchFrom.toLowerCase()) : false;
  })
  .slice(0, 10)
  .map((teacher) => ({
    type: "teacher",
    label: `${teacher.fname} ${teacher.username}`,
    sub: `Teacher ID: ${teacher.teach_id || "N/A"}`,
    value: teacher,
  }));

   // 👩‍🏫 Teachers Search (for "Move To" input)
  const filteredToTeacher = (teachers || [])
  .filter((teacher) => {
    const fullName = `${teacher.fname || ""} ${teacher.username || ""}`.toLowerCase();
    return searchTo ? fullName.includes(searchTo.toLowerCase()) : false;
  })
  .slice(0, 10)
  .map((teacher) => ({
    type: "teacher",
    label: `${teacher.fname} ${teacher.username}`,
    sub: `Teacher ID: ${teacher.teach_id || "N/A"}`,
    value: teacher,
  }));


    
  return (
    <div className="bg-back">
      <Header />
      <Sidebar />

      <div className="docs-wrapper bg-back">
        <div className="container-fluid pt-lg-10 pt-2 pb-10 pb-lg-10">
          <div className="px-2 px-lg-4">
            <div className="row gx-6 gy-6">
              <div className="col-12">
                <div className="fs-t text-q2 fw-medium">
                  <i className="bi bi-stars text-warning"></i>
                  <span className="ms-2">Control All App Settings.</span>
                </div>
              </div>

              <div className="col-lg-8">
                <div
                  className="border border-0 bg-white"
                  style={{ borderRadius: "30px" }}
                >
                  <div className="row align-items-center">
                    <div className="col-lg-7">
                      <div
                        className="card shadow-none bg-light py-lg-2"
                        style={{
                          backgroundImage: "url('../../assets/images/background/11.svg')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          backgroundPosition: "100% 5%",
                          borderRadius: "30px",
                        }}
                      >
                        <div className="px-lg-6 py-lg-8 px-6 py-6">
                          {loading ?
                          <div className="text-center">
                           <div className="lds-ellipsis">
                           <div></div>
                           <div></div>
                           <div></div>
                           <div></div>
                           </div>
                           </div>
                          :
                          <div>
                            <span className="fs-5 text-purple2 fw-medium">Total Units</span>
                            <div className="fs-t2 text-purple3 fw-semibold mt-lg-2 mt-2 pb-1">
                              ₦{wallet.wallet_balance.toFixed(2)}
                            </div>
                            <div className="col-8 border border-dark rounded-3 px-2">
                              <div className="text-purple2 fs-6">
                                Wallet ID: {wallet.wallet_id}
                              </div>
                            </div>

                            <div className="d-lg-flex mt-lg-4 mt-4">
                              <button
                                className="btn btn-md btn-purple4 text-white fs-5"
                                style={{ borderRadius: "20px" }}
                                data-bs-toggle="modal"
                                data-bs-target="#paymentModal"
                              >
                                Top-up <i className="bi bi-plus-circle-fill"></i>
                              </button>

                              <button
                                className="btn btn-md btn-white ms-3 fs-5"
                                style={{ borderRadius: "20px" }}
                              >
                                History
                              </button>
                            </div>
                          </div>
                          }
                        </div>
                      </div>
                    </div>

                    {/* Right Section */}
                    <div className="col-lg-5">
                      <div className="py-8 px-4">
                      {loading ?
                       <div className="text-center">
                       <div className="lds-ellipsis">
                       <div></div>
                       <div></div>
                       <div></div>
                       <div></div>
                       </div>
                       </div>
                      :
                        <>
                        <div>
                          <div className="fs-5 fw-medium text-dark">Total Deposits</div>
                          <span className="fs-t fw-medium text-dark-success">
                            ₦{wallet.total_income.toFixed(2)}
                          </span>
                        </div>

                        <div className="py-2">
                          <hr />
                        </div>

                        <div>
                          <div className="fs-5 fw-medium text-dark">Total Spending</div>
                          <span className="fs-t fw-medium text-dark-danger">
                            ₦{wallet.total_deductions.toFixed(2)}
                          </span>
                        </div>
                        </>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4"
              data-bs-toggle="offcanvas" data-bs-target="#student_control" aria-controls="offcanvasScrolling">
                <div
                  className={`card shadow-none position-relative overflow-hidden ${isMobile ? 'border border-secondary' : ''}`}
                  style={{
                    backgroundImage: "url('../../assets/images/background/9.svg')",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover", // full visible image
                    backgroundPosition: "center",
                    borderRadius: "30px", // round entire background card
                    minHeight: "350px", // adjust height for visibility
                  }}
                >
                  {/* White content card - positioned at bottom start */}
                  <div
                    className="position-absolute top-0 start-0 w-100"
                    style={{ padding: "0px" }}
                  >
                    <div
                      className="border-0 text-center px-lg-6 px-4"
                      style={{
                        borderRadius: "30px",
                        maxWidth: "100%",
                      }}
                    >
                      <div className="fs-3 text-dark fw-medium mt-5 mb-3">
                        Manage all students and activities
                      </div>
                      <div className="">
                      <button className="btn btn-purple rounded-pill">
                        <i className="bi bi-arrow-right"></i>
                      </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-8 order-2 order-lg-1">
                <div className="card bg-white shadow-none"
                style={{
                  backgroundImage: "url('../../assets/images/background/10.svg')",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover", // full visible image
                  backgroundPosition: "80% 100%",
                  borderRadius: "30px", // round entire background card
                }}>
                   <div className="py-lg-4 px-lg-4 px-2 py-4">
                    <div className="card-header bg-transparent">
                      <div className="fs-3 fw-medium text-purple2">
                      <i class="bi bi-sliders"></i> Manage All App Activity
                      </div>
                    </div>

                    <div className="px-lg-4 py-lg-4 px-2 py-2">
                      <div className="d-flex gap-3 bg-back p-4 mb-4">
                        <div className="col-auto fs-4 fw-medium">
                          1.
                        </div>
                        <div className="col fs-4 fw-medium text-gray-700">
                          Activate and setup E-Payment System
                        </div>
                        <div className="col-end">
                          <div class="form-check form-switch mb-2">
                            <input class="form-check-input" type="checkbox" 
                            role="switch" id="flexSwitchCheckChecked"/>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex gap-3 bg-back p-4 mb-4">
                        <div className="col-auto fs-4 fw-medium">
                          2.
                        </div>
                        <div className="col fs-4 fw-medium text-gray-700">
                          Activate and setup Birthday Notification
                        </div>
                        <div className="col-end">
                          <div class="form-check form-switch mb-2">
                            <input class="form-check-input" type="checkbox" 
                            role="switch" id="flexSwitchCheckChecked"/>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex gap-3 bg-back p-4">
                        <div className="col-auto fs-4 fw-medium">
                          3.
                        </div>
                        <div className="col fs-4 fw-medium text-gray-700">
                          Activate and setup CBT SMS and Email Notification
                        </div>
                        <div className="col-end">
                          <div class="form-check form-switch mb-2">
                            <input class="form-check-input" type="checkbox" 
                            role="switch" id="flexSwitchCheckChecked"/>
                          </div>
                        </div>
                      </div>

                    </div>

                   </div>
                </div>
              </div>

              <div className="col-lg-4 order-1 order-lg-2"
              data-bs-toggle="offcanvas" data-bs-target="#teacher_control" aria-controls="offcanvasScrolling">
                <div
                  className={`card shadow-none position-relative overflow-hidden ${isMobile ? 'border border-secondary' : ''}`}
                  style={{
                    backgroundImage: "url('../../assets/images/background/9.svg')",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover", // full visible image
                    backgroundPosition: "center",
                    borderRadius: "30px", // round entire background card
                    minHeight: "350px", // adjust height for visibility
                  }}
                >
                  {/* White content card - positioned at bottom start */}
                  <div
                    className="position-absolute top-0 start-0 w-100"
                    style={{ padding: "0px" }}
                  >
                    <div
                      className="border-0 text-center px-lg-6 px-4"
                      style={{
                        borderRadius: "30px",
                        maxWidth: "100%",
                      }}
                    >
                      <div className="fs-3 text-dark fw-medium mt-5 mb-3">
                        Manage all teachers and activities
                      </div>
                      <div className="">
                      <button className="btn btn-purple rounded-pill">
                        <i className="bi bi-arrow-right"></i>
                      </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>


      <div
        className="modal fade"
        id="paymentModal"
        tabIndex="-1"
        aria-labelledby="paymentModalLabel"
        aria-hidden="true"
        >
        <div
          className={
            isMobile
              ? "modal-dialog modal-dialog-centered modal-fullscreen"
              : "modal-dialog modal-dialog-centered"
          }
        >
          <div className="modal-content border-0"
          style={ isMobile ? {} : {borderRadius: '30px'} }>
            <div className="modal-header border-0 px-4 pt-3">
              <div className="fs-t fw-medium text-dark">
                <i className="bi bi-wallet2 text-success fs-t"></i> Wallet Top-Up
              </div>
              <button
                type="button"
                className="btn btn-purple4 btn-icon rounded-br-lg2 rounded-bl-sm2 rounded-t-lg2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="bi bi-x-lg fw-bold fs-5 text-white"></i>
              </button>
            </div>

            <div className="modal-body text-start py-4">
              <div className="container px-lg-6 px-2 mt-7 mt-lg-1">
                <div className="mb-8 mb-lg-4">
                  <div className="fs-4 fw-medium text-dark mb-2">Email</div>
                  <input
                    type="email"
                    className="form-control form-control-lg bg-back rounded-pill text-dark"
                    placeholder="Enter your email"
                    value={email}
                    disabled
                  />
                </div>

                <div className="mb-8 mb-lg-4">
                  <div className="fs-4 fw-medium text-dark mb-2">Amount (₦)</div>
                  <input
                    type="number"
                    className="form-control form-control-lg bg-back rounded-pill text-center text-dark"
                    placeholder="Enter amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </div>

                <div className="d-grid mt-6 mt-lg-4 text-center">
                  <PaystackPayment
                    email={email}
                    amount={amount}
                    onSuccess={handleSuccess}
                    onClose={() => toast.error("Payment was cancelled! Good Luck!")}
                  />
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="offcanvas offcanvas-end bg-white"
       tabindex="-1" id="student_control" aria-labelledby="offcanvasWithBackdropLabel"
       style={
          isMobile
            ? { width: "600px", }
            : {
                width: "600px",
              }
        }
       >
        <div className="offcanvas-header align-items-center shadow-none py-3 px-4">
          <div className="text-dark m-0 fs-3" id="offcanvasRightLabel">
            <i className="bi bi-app-indicator text-dark"></i> Transfer Students
          </div>
          <button
            type="button"
            className="btn btn-purple4 btn-icon rounded-br-lg2 rounded-bl-sm2 rounded-t-lg2"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="bi bi-x-lg fw-bold fs-4 text-white"></i>
          </button>
        </div>

        <div class="offcanvas-body">
          <div className="px-lg-4 px-4">
            <div className="mt-6 mt-lg-4">

              <div className="fs-3 text-dark">
                Select <span className="fw-medium">Class or Student</span> you want to move from one to another.{" "}
                <span>
                  <i className="bi bi-stars text-warning"></i> Tip: Start From Highest Class To Lowest Class
                </span>
              </div>

              <form className="mt-4 mt-lg-6 position-relative">
                {/* Move From */}
                <div className="mb-3 position-relative">
                  <div className="fw-medium fs-4 text-dark mb-3">Move From</div>
                  <input
                    value={searchFrom}
                    onChange={(e) => {
                      setSearchFrom(e.target.value);
                      setSelectedFrom(null);
                    }}
                    className="form-control form-control-lg bg-back text-dark"
                    placeholder="Type Student Name, ID or Class"
                    style={{ borderRadius: "20px" }}
                  />

                  {/* Dropdown */}
                  {searchFrom && !selectedFrom && filteredFrom.length > 0 && (
                    <ul
                      className="list-group position-absolute bg-white w-100 shadow-sm mt-1"
                      style={{ zIndex: 10, borderRadius: "40px", maxHeight: "200px", overflowY: "auto" }}
                    >
                      {filteredFrom.map((option, index) => (
                        <li
                          key={index}
                          className="list-group-item list-group-item-action px-lg-6"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSelect(setSearchFrom, setSelectedFrom, option)}
                        >
                          <div className="fw-medium d-flex justify-content-between text-dark fs-4">
                            <span>{option.label}</span>
                            <small className="fs-4 text-dark">
                              {option.type === "class" ? "" : ""}
                            </small>
                          </div>
                          <small className="text-dark">{option.sub}</small>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="mb-2 text-center">
                  <i className="bi bi-arrow-down-up fw-bold fs-t3 text-dark"></i>
                </div>

                {/* Move To */}
                <div className="mb-6 position-relative">
                  <div className="fw-medium fs-4 text-dark mb-3">Move To</div>
                  <input
                    value={searchTo}
                    onChange={(e) => {
                      setSearchTo(e.target.value);
                      setSelectedTo(null);
                    }}
                    className="form-control form-control-lg bg-back text-dark"
                    placeholder="Type Student Name, ID or Class"
                    style={{ borderRadius: "20px" }}
                  />

                  {/* Dropdown */}
                  {searchTo && !selectedTo && filteredTo.length > 0 && (
                    <ul
                      className="list-group position-absolute w-100 shadow-sm mt-1"
                      style={{ zIndex: 10, borderRadius: "40px", maxHeight: "200px", overflowY: "auto" }}
                    >
                      {filteredTo.map((option, index) => (
                        <li
                          key={index}
                          className="list-group-item list-group-item-action px-lg-6 bg-white"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSelect(setSearchTo, setSelectedTo, option)}
                        >
                          <div className="fw-semibold d-flex justify-content-between text-dark fs-4">
                            <span>{option.label}</span>
                            <small className="text-dark">
                              {option.type === "class" ? "" : ""}
                            </small>
                          </div>
                          <small className="text-dark">{option.sub}</small>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="d-grid">

                <button
                  className="btn btn-purple btn-lg fs-4 d-flex align-items-center justify-content-center gap-2"
                  style={{ borderRadius: "20px", minWidth: "180px", height: "55px" }}
                  type="button"
                  disabled={isloading}
                  onClick={async () => {
                    if (!selectedFrom || !selectedTo) {
                      toast.warning("Please select both fields before transferring.");
                      return;
                    }

                    const moveMessage = `Move ${selectedFrom.label} to ${selectedTo.label}`;

                    console.log("🔹 AI Message:", moveMessage);

                    try {
                      setisLoading(true);

                      const userMsg = { role: "user", content: moveMessage };
                      const updatedHistory = [userMsg];

                      const result = await getAiResponse(updatedHistory);

                      console.log("🤖 AI Response:", result);
                      toast.success("AI Response: " + (result || "Success"));
                    } catch (error) {
                      console.error("❌ Error sending AI message:", error);
                      toast.error("Failed to send message to AI.");
                    } finally {
                      setisLoading(false);
                    }
                  }}
                >
                  {isloading ? (
                    <div className="lds-facebook">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  ) : (
                    "Transfer Now"
                  )}
                </button>
                
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>

      <div class="offcanvas offcanvas-end bg-white"
       tabindex="-1" id="teacher_control" aria-labelledby="offcanvasWithBackdropLabel"
       style={
          isMobile
            ? { width: "600px", }
            : {
                width: "600px",
              }
        }
       >
        <div className="offcanvas-header align-items-center shadow-none py-3 px-4">
          <div className="text-dark m-0 fs-3" id="offcanvasRightLabel">
            <i className="bi bi-app-indicator text-dark"></i> Transfer Teachers
          </div>
          <button
            type="button"
            className="btn btn-purple4 btn-icon rounded-br-lg2 rounded-bl-sm2 rounded-t-lg2"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="bi bi-x-lg fw-bold fs-4 text-white"></i>
          </button>
        </div>

        <div class="offcanvas-body">
          <div className="px-lg-4 px-4">
            <div className="mt-6 mt-lg-4">

              <div className="fs-3 text-dark">
                Select <span className="fw-medium">Class or Teacher</span> you want to move from one to another.{" "}
                <span>
                  <i className="bi bi-stars text-warning"></i> Tip: Move Teachers via Name to Class
                </span>
              </div>

              <form className="mt-4 mt-lg-6 position-relative">
                {/* Move From */}
                <div className="mb-3 position-relative">
                  <div className="fw-medium fs-4 text-dark mb-3">Move From</div>

                  <input
                    value={searchFrom}
                    onChange={(e) => {
                      setSearchFrom(e.target.value);
                      setSelectedFrom(null);
                    }}
                    className="form-control form-control-lg bg-back text-dark"
                    placeholder="Type Teacher Name"
                    style={{ borderRadius: "20px" }}
                  />

                  {/* Dropdown */}
                  {searchFrom && !selectedFrom && filteredFromTeacher.length > 0 && (
                    <ul
                      className="list-group position-absolute bg-white w-100 shadow-sm mt-1"
                      style={{
                        zIndex: 10,
                        borderRadius: "40px",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {filteredFromTeacher.map((option, index) => (
                        <li
                          key={index}
                          className="list-group-item list-group-item-action px-lg-6"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSelect(setSearchFrom, setSelectedFrom, option)}
                        >
                          <div className="fw-medium d-flex justify-content-between text-dark fs-4">
                            <span>{option.label}</span>
                          </div>
                          <small className="text-dark">{option.sub}</small>
                        </li>
                      ))}
                    </ul>
                  )}

                </div>

                <div className="mb-2 text-center">
                  <i className="bi bi-arrow-down-up fw-bold fs-t3 text-dark"></i>
                </div>

                {/* Move To */}
                <div className="mb-6 position-relative">
                  <div className="fw-medium fs-4 text-dark mb-3">Move To</div>
                  
                  <input
                    value={searchTo}
                    onChange={(e) => {
                      setSearchTo(e.target.value);
                      setSelectedTo(null);
                    }}
                    className="form-control form-control-lg bg-back text-dark"
                    placeholder="Type Teacher Name"
                    style={{ borderRadius: "20px" }}
                  />

                  {/* Dropdown */}
                  {searchTo && !selectedTo && filteredToTeacher.length > 0 && (
                    <ul
                      className="list-group position-absolute bg-white w-100 shadow-sm mt-1"
                      style={{
                        zIndex: 10,
                        borderRadius: "40px",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {filteredToTeacher.map((option, index) => (
                        <li
                          key={index}
                          className="list-group-item list-group-item-action px-lg-6"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSelect(setSearchTo, setSelectedTo, option)}
                        >
                          <div className="fw-medium d-flex justify-content-between text-dark fs-4">
                            <span>{option.label}</span>
                          </div>
                          <small className="text-dark">{option.sub}</small>
                        </li>
                      ))}
                    </ul>
                  )}

                </div>

                <div className="d-grid">

                <button
                  className="btn btn-purple btn-lg fs-4 d-flex align-items-center justify-content-center gap-2"
                  style={{ borderRadius: "20px", minWidth: "180px", height: "55px" }}
                  type="button"
                  disabled={isloading}
                  onClick={async () => {
                    if (!selectedFrom || !selectedTo) {
                      toast.warning("Please select both fields before transferring.");
                      return;
                    }

                    const moveMessage = `Move Teacher ${selectedFrom.label} ${selectedFrom.sub} class to Teacher ${selectedTo.label} ${selectedTo.sub} class`;
                    console.log("🔹 AI Message:", moveMessage);

                    try {
                      setisLoading(true);

                      const userMsg = { role: "user", content: moveMessage };
                      const updatedHistory = [userMsg];

                      const result = await getAiResponse(updatedHistory);

                      console.log("🤖 AI Response:", result);
                      toast.success("AI Response: " + (result || "Success"));
                    } catch (error) {
                      console.error("❌ Error sending AI message:", error);
                      toast.error("Failed to send message to AI.");
                    } finally {
                      setisLoading(false);
                    }
                  }}
                >
                  {isloading ? (
                    <div className="lds-facebook">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  ) : (
                    "Transfer Now"
                  )}
                </button>
                
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Control;
